/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.18.0
 * @since 1.17.0
 */

import { IPageAutoReportIdTranslation } from '../../types';

export const initPageAutoReportIdTranslation: IPageAutoReportIdTranslation = {
    sideMenu: {
        accounts: '',
        formatDelivery: '',
        scheduleParameters: '',
        subscribers: '',
    },

    formatDelivery: {
        fields: {
            reportFormat: '',
            notifyByPhoneEnabled: '',
            notifyByPhone: '',
            notifyByEmailEnabled: '',
            notifyByEmail: '',
            sendByEmailEnabled: '',
            sendByEmail: '',
            sendByEmailZip: '',
            sendByEmailZipPasswordEnabled: '',
            sendByEmailZipPassword: '',
        },
        groups: {
            documentation: '',
            format: '',
            notification: '',
        },
        save: {
            error: '',
            success: '',
        },
    },

    table: {
        title: {
            dropFilters: '',
        },
        footer: {
            cancel: '',
            save: '',
        },
    },

    accounts: {
        table: {
            name: { header: '', dataName: '' },
            number: { header: '', dataName: '' },
            delete: { header: '', dataName: '' },
        },
        title: {
            edit: '',
            label: '',
        },
    },

    accountsEdit: {
        title: {
            label: '',
        },
    },

    subscribers: {
        table: {
            msisdn: { header: '', dataName: '' },
            name: { header: '', dataName: '' },
            delete: { header: '', dataName: '' },
        },
        title: {
            edit: '',
            label: '',
        },
    },

    subscribersEdit: {
        title: {
            label: '',
        },
    },
};
